import {
    IWechatService,
} from './interface';
import { SlideDataServices, onSlideAppReady } from '@src/slide/domain/slide-app/core/slide-data-services.core';

export class WechatService implements IWechatService {
    public setSlideTitleAfterReady = () => {
        onSlideAppReady(() => {
            const { title = '' } = SlideDataServices.SlideTitleManager() || {};
            window.wx?.miniProgram?.postMessage?.({
                data: {
                    title,
                    type: 4,
                },
            });
        });
    };
}
